'use client'

import { Button } from '@/General/Button'
import { useSubscriptionEligibility } from '@/useSubscriptionEligibility'
import MasterclassSubscribeButton from '../AddToCart'

const buttonClass =
  'mt-8 rounded-md bg-emerald-600 px-6 py-3 text-base font-semibold shadow-md hover:bg-emerald-700 text-white'

interface StudioCTAProps {
  productId?: number
  className?: string
}

export const StudioCTA = ({
  productId = 19483,
  className = '',
}: StudioCTAProps) => {
  const { isSubscriber, isLoading, isLoggedIn } = useSubscriptionEligibility()

  if (isSubscriber) {
    return (
      <Button
        href="/account/studio/"
        className={`${buttonClass} ${className}`.trim()}
      >
        Go to your VI Studio
      </Button>
    )
  }

  if (isLoading && isLoggedIn) {
    return (
      <Button className={`${buttonClass} ${className}`.trim()} disabled>
        Loading...
      </Button>
    )
  }

  return (
    <MasterclassSubscribeButton
      productId={productId}
      className={className}
    />
  )
}
